(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Adds 'Back to top' functionality to an element with the ID 'back-to-top'
 * @example 
 * 1. Create a link-wrapper with ID 'back-to-top'
 * 2. Add an icon inside the link-wrapper such as an arrow
 * 3. Set position fixed: bottom right
 * 4. Set opacity to 0
 */
var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var DocsMenu =
/*#__PURE__*/
function () {
  function DocsMenu() {
    _classCallCheck(this, DocsMenu);

    // Check if exists and initialize
    this.$var = $('.docs-nav');

    if (this.$var.length > 0) {
      this.init();
    }
  }

  _createClass(DocsMenu, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      $('.menu-category').on('click', function (e) {
        var $el = $(e.currentTarget);
        var $parent = $el.parent('.menu-group');
        var is_expanded = $parent.hasClass('active');
        $('.docs-nav .menu-group').removeClass('active');
        console.log(is_expanded);

        if (!is_expanded) {
          $parent.addClass('active');
        }
      });
    }
  }]);

  return DocsMenu;
}();

var _default = DocsMenu;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var GiftCardsMenu =
/*#__PURE__*/
function () {
  function GiftCardsMenu() {
    _classCallCheck(this, GiftCardsMenu);

    // Check if exists and initialize
    this.$var = $('.gift-cards-nav');

    if (this.$var.length > 0) {
      this.init();
    }
  }

  _createClass(GiftCardsMenu, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      $('.cat-parent .cat-toggle').on('click', function (e) {
        $(e.currentTarget).parent('.cat-parent').toggleClass('expand');
      });
    }
  }]);

  return GiftCardsMenu;
}();

var _default = GiftCardsMenu;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Event handlers for Infinite Scroll
 */
var InfiniteScrollHandler =
/*#__PURE__*/
function () {
  function InfiniteScrollHandler() {
    _classCallCheck(this, InfiniteScrollHandler);

    // Check if exists and initialize
    this.$infScrollWrapper = $('.js-inf-scroll-load');

    if (this.$infScrollWrapper.length > 0) {
      this.init();
    }
  }

  _createClass(InfiniteScrollHandler, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      $(document).on('request.infiniteScroll', function () {
        _this.handleInfiteLoad();
      });
      $(document).on('append.infiniteScroll', function () {
        _this.handleInfiniteLoadComplete();
      });
    }
  }, {
    key: "handleInfiteLoad",
    value: function handleInfiteLoad(e) {// find button -> Hide it
      // Make sure GIF spinner is spinning
    }
  }, {
    key: "handleInfiniteLoadComplete",
    value: function handleInfiniteLoadComplete() {// find button -> make visible
    }
  }]);

  return InfiniteScrollHandler;
}();

var _default = InfiniteScrollHandler;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var ToC =
/*#__PURE__*/
function () {
  function ToC() {
    _classCallCheck(this, ToC);

    // Check if exists and initialize
    this.$toc = $('.pro-table-of-contents');

    if (this.$toc.length > 0) {
      this.init();
    }
  }

  _createClass(ToC, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Check if ToC is expanded onLoad
      var isExpanded = this.$toc.find('.oxy-toc > button').hasClass('active'); // Add .active class to pro element

      if (isExpanded) {
        this.$toc.addClass('active');
      } // Toggle .active class on click


      this.$toc.find('button').on('click', function () {
        _this.$toc.toggleClass('active');
      }); // Get the offset of the ToC

      this.$toc_parent = this.$toc.parent();
      this.toc_offset = this.$toc_parent.offset();
      this.toc_max_offset = this.toc_offset.top + this.$toc_parent.outerHeight(false); // console.log(this.toc_offset.top);
      // console.log(this.toc_max_offset);
      // Create scroll event listener for sticky ToC

      $(window).on('scroll', function (e) {
        return _this.stickyTocWatcher(e);
      }); // Set the starting state of the ToC based on load position

      var startingPosition = $(window).scrollTop();
      this.setTocStickyState(startingPosition);
    }
    /**
    *   We need to check if the user has scrolled and pass that
    *   scroll distance to our state handler
    **/

  }, {
    key: "stickyTocWatcher",
    value: function stickyTocWatcher(e) {
      var scrollDistance = e.currentTarget.pageYOffset;
      this.setTocStickyState(scrollDistance); // console.log(scrollDistance);
    }
    /**
    *   State Handler: set the state based on scrollDistance and original offset
    **/

  }, {
    key: "setTocStickyState",
    value: function setTocStickyState(scrollDistance) {
      if (scrollDistance > this.toc_offset.top & scrollDistance < this.toc_max_offset) {
        this.$toc.addClass('sticky');
      } else {
        this.$toc.removeClass('sticky');
      }
    }
  }]);

  return ToC;
}();

var _default = ToC;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Opens social sharing links in a small popup window
 * @example 
 * 1. Add the class .js-social-share-popup to social share links
 */
var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],7:[function(require,module,exports){
"use strict";

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _infiniteScrollHandlers = _interopRequireDefault(require("./modules/infinite-scroll-handlers"));

var _docsMenu = _interopRequireDefault(require("./modules/docs-menu"));

var _giftCardsMenu = _interopRequireDefault(require("./modules/gift-cards-menu"));

var _proTableOfContents = _interopRequireDefault(require("./modules/pro-table-of-contents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
window.$ = jQuery;
$(document).ready(function () {
  $('html').addClass('js-on-load');
  var backToTop = new _backToTop.default();
  var socialSharePopups = new _socialSharePopups.default();
  var infiniteScrollHandler = new _infiniteScrollHandlers.default();
  var docsMenu = new _docsMenu.default();
  var giftCardsMenu = new _giftCardsMenu.default();
  var toc = new _proTableOfContents.default(); // plugin('ResponsiveTabs', ResponsiveTabs);
});

},{"./modules/back-to-top":1,"./modules/docs-menu":2,"./modules/gift-cards-menu":3,"./modules/infinite-scroll-handlers":4,"./modules/pro-table-of-contents":5,"./modules/social-share-popups":6}]},{},[7]);
